<template>
  <div>
    <header
      id="site-header"
      class="site-header"
      :class="{ open: isOpen }"
    >
      <div class="top-area">
        <div class="flex justify-between content-max-width ">

          <a href="/" class="logo">
            <img src="/images/logo.png" alt="Promed Technnologies logo" />
          </a>

          <div>
            <a :href="'tel:'+data.phone_url" class="tel">{{ data.phone }}</a>            
            <a :href="'mailto:'+data.email" class="email">{{ data.email }}</a>
          </div>
        </div>
      </div>
      <button class="hamburger" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="search mob" @click="showingSearch = true">
        <img src="/images/search.svg" alt="">
      </div>

      <nav class="flex">
        <div class="search" @click="toggleSearch(true)">
          <img src="/images/search.svg" alt="">
        </div>
        <ul>
          <app-collapsible tag="li" @click.native.stop="showingProductsDropdown = true">
          <!-- <li @click="showingProductsDropdown = true"> -->
            <template #trigger="{ isOpen, toggle }">
              <a class="flex items-center" @click="toggle">
                <img src="/images/products.svg" alt="" class="desktop">
                Products
                <img :src="`/images/${isOpen ? 'minus' : 'plus'}.svg`" alt="" class="mob">
              </a>
            </template>
            <template #collapsible="{ isOpen }">
              <div v-show="isOpen" class="mob product-category">
                <app-collapsible
                  v-for="category in categories"
                  :key="category.slug"
                  class="flex items-center justify-between category"
                >
                  <template #trigger="{ toggle }">
                    <span @click="toggle">{{ category.title }}</span>
                    <img src="/images/menu-right.svg" alt="" @click="toggle">
                  </template>

                  <template #collapsible="{ isOpen, close }">
                    <div v-show="isOpen" class="children">
                      <div class="flex items-center back" @click="close">
                        <img src="/images/menu-right.svg" alt="">
                        <span>Menu</span>
                      </div>
                      <a
                        class="title"
                        :href="`/category/${category.slug}`"
                      >
                        {{ category.title }}
                      </a>
                      <a
                        v-for="product in category.products"
                        :key="product.slug"
                        :href="`/products/${product.slug}`"
                      >
                        {{ product.title }}
                      </a>
                    </div>
                  </template>
                </app-collapsible>
              </div>
            </template>
          </app-collapsible>
          <li><a href="/our-brands">Our Brands</a></li>
          <li><a href="/about-us">About Us</a></li>
          <li><a href="/our-people">Our People</a></li>
          <li><a href="/contact">Contact</a></li>
          <!-- <li
            v-for="(link, index) of nav"
            :key="index"
            :class="selectedClass(link.url)"
          >
            <a :href="link.url" @click="clickItem(link.url)">
              {{ link.title }}
              <span class="icon top material-icons" v-if="link.children">expand_more</span>
            </a>

            <ul v-if="link.children">
              <li
                v-for="(child, index) of link.children"
                :key="index"
              >
                <a :href="child.url">
                  <span>{{ child.title }}</span>
                  <span class="icon material-icons">navigate_next</span>
                </a>
              </li>
            </ul>
          </li> -->

        </ul>
      </nav>

      <nav v-show="showingSearch" class="flex items-center justify-between search">
        <img src="/images/search-close.svg" alt="" class="close" @click="toggleSearch(false)">
        <input type="text" ref="searchtext" v-model="search" v-debounce:750ms="liveSearch" v-on:keyup.enter="enterSearch">
        <img src="/images/search.svg" alt="">
      </nav>

    </header>

    <div v-show="showingSearch && results.length" class="related-dropdown">
      <h6>Related Items</h6>
      <a :href="link.url" v-for="(link, key) of results" :key="key">
          {{ link.title }}
      </a>
      <!-- <a href=""><span class="red">{{ search }}</span> quae</a>
      <a href="">Quid <span class="red">{{ search }}</span> ea quid</a>
      <a href="">At magnum <span class="red">{{ search }}</span></a>
      <a href="">Si <span class="red">{{ search }}</span> causa</a>
      <a href=""><span class="red">{{ search }}</span> videro</a> -->
    </div>

    <div v-show="showingProductsDropdown" class="product-dropdown desktop" v-on-clickaway="closeProductsDropdown">
      <div class="flex">
        <div class="left">
          <a
            v-for="category in categories"
            :key="category.slug"
            :href="`/category/${category.slug}`"
            @mouseover="activeDesktopCategoryId = category.id"
          >
            {{ category.title }}
          </a>
        </div>
        <div class="right">
          <a href="/products" class="button">View All Products</a>
          <div class="columns">
            <a
              v-for="product in products"
              :key="product.slug"
              :href="`/products/${product.slug}`"
            >
              {{ product.title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
  directives: {
    onClickaway,
  },

  props: {
    menu: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    search_url:{
      type: String,
      required: true
    },
    results_url:{
      type: String,
      required: true
    }

  },

  data () {
    return {
      isOpen: false,
      nav: [],
      currentUrl: window.location.href,
      showingSearch: false,
      showingProductsDropdown: false,
      search: '',
      activeDesktopCategoryId: this.categories[0].id,
      payload: {
        q: ''
      },
      results: [],
    }
  },

  watch: {
    showingSearch (newValue) {
      if (newValue) {
        this.showingProductsDropdown = false        
      }
    },
  },

  computed: {
    products () {
      const category = this.categories.find(category => category.id === this.activeDesktopCategoryId)

      return category.products
    },
  },

  mounted () {
    this.nav = this.menu
  },

  methods: {
    toggleSearch() {      
      this.showingSearch = !this.showingSearch
      if (this.showingSearch) {
        this.$nextTick(() => this.$refs.searchtext.focus())
      }
    },

    toggleMenu () {
      this.isOpen = !this.isOpen;
    },

    closeProductsDropdown () {
      this.$nextTick(() => {
        if (this.showingProductsDropdown) {
          this.showingProductsDropdown = false
        }
      })
    },

    selectedClass (link) {
      if (link === this.currentUrl) {
        return 'selected'
      }

      if (link === this.currentUrl.substr(this.currentUrl.length-1)) {
        return 'selected'
      }
    },

    clickItem (url) {
      if (url === '#') {
        console.log(url)
      }
    },

    enterSearch(){
      if(this.search.length) {
        location.href = this.results_url + '?q='+this.search
      }
    },

    liveSearch () {
      this.payload.q = this.search
      window.axios.post(this.search_url, this.payload)
        .then((response) => {
          this.results = response.data.data
        })
        .catch((error) => {
          console.log('prod error', error)

        })
    },
  },
};
</script>
